import { FunctionComponent } from 'react';

const MoreInfo: FunctionComponent = function () {
  return <p>MoreInfo</p>;
};

export default MoreInfo;
